import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function BrandHub() {
  const [clients, setClients] = useState([]);
  const [selected, setSelected] = useState(null);
  const [assets, setAssets] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/clients");
      setClients(data);
      if (data.length) setSelected(data[0].id);
    })();
  }, []);

  useEffect(() => {
    if (!selected) return;
    (async () => {
      const { data } = await api.get(`/brand-assets/client/${selected}`);
      setAssets(data);
    })();
  }, [selected]);

  const BACKEND = process.env.REACT_APP_BACKEND_URL;

  return (
    <div className="p-8 md:p-12 animate-fade-up">
      <p className="eyebrow mb-2">Pillar 3 · Brand Hub</p>
      <h1 className="text-4xl font-bold tracking-tight text-slate-900 mb-8" data-testid="brand-hub-title">Brand Hub</h1>

      {clients.length === 0 ? (
        <div className="bento p-8 text-slate-500">No clients yet.</div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="bento p-4 lg:col-span-1" data-testid="client-picker">
            <p className="eyebrow mb-3 px-2">Clients</p>
            <div className="space-y-1">
              {clients.map((c) => (
                <button
                  key={c.id}
                  onClick={() => setSelected(c.id)}
                  className={`w-full text-left px-3 py-2 rounded-xl text-sm ${selected === c.id ? "bg-slate-900 text-white" : "hover:bg-slate-100 text-slate-700"}`}
                  data-testid={`brand-client-${c.id}`}
                >
                  {c.name}
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3 space-y-6">
            <div className="bento p-8" data-testid="logos-card">
              <p className="eyebrow mb-4">Logos</p>
              {assets?.logo_urls?.length ? (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {assets.logo_urls.map((u, i) => (
                    <div key={`${u}-${i}`} className="aspect-square rounded-2xl bg-slate-50 border border-slate-200 p-4 flex items-center justify-center">
                      <img src={BACKEND + u} alt="logo" className="max-w-full max-h-full object-contain" />
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-slate-500">No logos uploaded yet. Client can upload via portal.</p>
              )}
            </div>

            <div className="bento p-8" data-testid="colors-card">
              <p className="eyebrow mb-4">Colors</p>
              {assets?.hex_codes?.length ? (
                <div className="flex flex-wrap gap-3">
                  {assets.hex_codes.map((h, i) => (
                    <div key={`${h}-${i}`} className="flex items-center gap-2 bg-slate-50 rounded-full pl-1 pr-3 py-1 border border-slate-200">
                      <div className="w-8 h-8 rounded-full border-2 border-white shadow-md" style={{ backgroundColor: h }} />
                      <code className="text-xs font-mono">{h}</code>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-slate-500">No colors specified.</p>
              )}
            </div>

            <div className="bento p-8" data-testid="typography-card">
              <p className="eyebrow mb-4">Typography notes</p>
              <p className="text-slate-700 whitespace-pre-wrap">{assets?.typography_notes || "No notes yet."}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
